export enum BATCH_TYPE {
  MASTER = 'master',
  BOOSTER = 'booster',
}
